/**
 * Trials API client.
 */
import { apiGet } from './client';
import type {
  TrialEventSummaryDto,
  FormMetadataDto,
  TrialEventRegistrationMetadataDto,
} from './types';

export const trialsApi = {
  /**
   * Get all active trial events.
   */
  list: () => apiGet<TrialEventSummaryDto[]>('/trial-events'),

  /**
   * Get a single trial event by ID.
   */
  getById: (trialEventId: string) => apiGet<TrialEventSummaryDto>(`/trial-events/${trialEventId}`),

  /**
   * Get form metadata for a trial event.
   */
  getFormMetadata: (trialEventId: string) =>
    apiGet<FormMetadataDto>(`/trial-events/${trialEventId}/form-metadata`),

  /**
   * Get registration metadata (trial config + form metadata).
   */
  getRegistrationMetadata: (trialEventId: string) =>
    apiGet<TrialEventRegistrationMetadataDto>(`/trial-events/${trialEventId}/registration/metadata`),
};
